/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Categories_Delete_ConfirmInputs */

const en_admin_categories_delete_confirm = /** @type {(inputs: Admin_Categories_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete this event?`)
};

const de_admin_categories_delete_confirm = /** @type {(inputs: Admin_Categories_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Veranstaltung wirklich löschen?`)
};

/**
* | output |
* | --- |
* | "Delete this event?" |
*
* @param {Admin_Categories_Delete_ConfirmInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_categories_delete_confirm = /** @type {((inputs?: Admin_Categories_Delete_ConfirmInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Categories_Delete_ConfirmInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_categories_delete_confirm(inputs)
	return en_admin_categories_delete_confirm(inputs)
});